import React, { lazy, Suspense } from 'react';

import { LoadingFallback } from './loading-fallback';

const Render = lazy(() => import('./render'));

export const LazyRenderer = (props: { value: string; className?: string }) => (
  <Suspense fallback={<LoadingFallback />}>
    <div className={props.className}>
      <Render {...props} />
    </div>
  </Suspense>
);
